import { File, History, Home, Live, SharedLive } from '@/features'

import { IRoute } from './navigation.types'

export const routes: IRoute[] = [
	{
		path: '/',
		component: Home
	},
	{
		path: '/live/shared/:token',
		component: SharedLive
	},
	{
		path: '/live/:id',
		component: Live
	},
	{
		path: '/file/:id',
		component: File
	},
	{
		path: '/history',
		component: History
	}
]

export default routes
